import Cookie from 'js-cookie';
import Axios from 'axios';

export const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authAxios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

axios.interceptors.request.use((config) => {
  const token = Cookie.get('authToken');
  config.headers.Authorization =  token ? `Bearer ${token}` : '';
  return config;
});